import { buildApiRequest } from 'utils/api';
import { BASE_URL } from 'utils/urls';

const urlHelper = {
  getUserByEmail: (params: any) => buildApiRequest('GET', `${BASE_URL}/odin/v2/permission/user/search?email=${params}`),
  getUserDetails: (params: any) => buildApiRequest('GET', `${BASE_URL}/odin/v2/permission/user/${params}`),
  updateUserDetails: (params: any) =>
    buildApiRequest('PUT', `${BASE_URL}/odin/v2/permission/user/${params.code}`, {
      name: params.name,
      email: params.email,
      phoneNo: params.phone,
      active: params.status,
    }),
  createUser: (params: any) =>
    buildApiRequest('POST', `${BASE_URL}/odin/v2/permission/user`, {
      name: params.name,
      email: params.email,
      phoneNo: params.phone,
    }),
  updateUserRoles: (params: any) =>
    buildApiRequest('PUT', `${BASE_URL}/odin/v2/permission/user/role`, {
      userCode: params.userCode,
      roles: params.roles,
    }),
  updateUserOdinPermissions: (params: any) =>
    buildApiRequest('PUT', `${BASE_URL}/odin/v2/permission/user/permissions`, {
      email: params.email,
      permissions: params.permissions,
    }),
};

export default urlHelper;
